import { useState, useEffect } from 'react';

export const useScrollPosition = () => {
  const [scrollOffset, setScrollOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const onScroll = () => {
      setScrollOffset({ x: window.pageXOffset, y: window.pageYOffset });
    };

    // Add listener and call its function once to get initial value
    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return scrollOffset;
};
